/**
 * @desc 手动上传跟踪号到paypal
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.ManualTrackingPayPalDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderPackage/trackingPaypal`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
